module.exports = __webpack_public_path__ + "img/广告-5 - 桃园结义.e3cbcad8.jpg";